import { cva } from "class-variance-authority";
import { HTMLAttributes } from "react";

type Rounded = "xs" | "sm" | "md" | "lg" | "xl" | "2xl";

const CHIP_ITEM_VARIANTS = cva(
  "flex-1 border flex items-center justify-center transition-colors hover:z-10",
  {
    variants: {
      roundedLeft: {
        xs: "rounded-s-none",
        sm: "rounded-s-none",
        md: "rounded-s-sm",
        lg: "rounded-s-md",
        xl: "rounded-s-lg",
        "2xl": "rounded-s-xl",
      },
      roundedRight: {
        xs: "rounded-e-none",
        sm: "rounded-e-none",
        md: "rounded-e-sm",
        lg: "rounded-e-md",
        xl: "rounded-e-lg",
        "2xl": "rounded-e-xl",
      },
    },
  }
);

type SelectChipsProps = Partial<{
  rounded: Rounded;
  children: React.ReactNode;
  className: string;
  classNames: Partial<{
    item: string;
  }>;
} & HTMLAttributes<HTMLDivElement>>;


export type {SelectChipsProps};
export {CHIP_ITEM_VARIANTS}